import styled from "@emotion/styled";
import { FC } from "react";

import { Avatar, DesignToken, SpacingToken, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { textEllipsisStyles } from "styles/common";
import { withVar } from "themes/helpers";

interface IProps {
  agentName: string;
  avatarUrl: string | null;
  secondaryText?: string;
  isLoggedInAgent?: boolean;
}

export const AgentPickerListItem: FC<IProps> = ({ agentName, avatarUrl, isLoggedInAgent, secondaryText }) => (
  <Flex alignItems="center" gap={withVar(SpacingToken.Spacing2)} data-testid={`list-item-${agentName}`}>
    <Avatar
      size={secondaryText !== undefined ? "small" : "xxsmall"}
      type={avatarUrl !== null ? "image" : "text"}
      shape="circle"
      src={avatarUrl ?? undefined}
      text={agentName}
    />
    <Content isSecondaryText={secondaryText !== undefined}>
      <Text bold={secondaryText !== undefined} css={textEllipsisStyles}>
        {agentName}
        {isLoggedInAgent && <span css={{ color: withVar(DesignToken.ContentBasicSecondary) }}> (You)</span>}
      </Text>
      {secondaryText && (
        <Text size="xs" customColor={withVar(DesignToken.ContentBasicSecondary)} css={textEllipsisStyles}>
          {secondaryText}
        </Text>
      )}
    </Content>
  </Flex>
);

const Content = styled.div<{ isSecondaryText?: boolean }>`
  display: flex;
  flex-direction: column;
  width: calc(
    100% - var(
        ${
          // FIXME: Fix this the next time the file is edited.
          // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
          ({ isSecondaryText }: any) => (isSecondaryText ? SpacingToken.Spacing10 : SpacingToken.Spacing7)
        }
      )
  );
`;

export const AgentPickerSelectedListItem: FC<IProps> = ({ agentName, avatarUrl }) => (
  <Flex maxWidth="100%" alignItems="center" gap={withVar(SpacingToken.Spacing2)}>
    <Avatar
      size="xxsmall"
      type={avatarUrl !== null ? "image" : "text"}
      shape="circle"
      src={avatarUrl ?? undefined}
      text={agentName}
    />
    <Text css={textEllipsisStyles}>{agentName}</Text>
  </Flex>
);
